import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from '../about/about.component';
import { LoginComponent } from '../auth/login/login.component';
import { SignupComponent } from '../auth/signup/signup.component';
import { AddBlogComponent } from '../admin/add-blog/add-blog.component';
import { ArchivalComponent } from '../blogs/archival/archival.component';
import { BlogsListComponent } from '../blogs/blogs-list/blogs-list.component';
import { CartComponent } from '../cart/cart.component';
import { ContactComponent } from '../contact/contact.component';
import { AddCourseComponent } from '../admin/add-course/add-course.component';
import { AddLessonComponent } from '../admin/add-lesson/add-lesson.component';
import { AddModuleComponent } from '../admin/add-module/add-module.component';
import { CourseDetailsComponent } from '../courses/course-details/course-details.component';
import { CourseListComponent } from '../courses/course-list/course-list.component';
import { CoursePlayComponent } from '../courses/course-play/course-play.component';
import { CourseWizardComponent } from '../admin/course-wizard/course-wizard.component';
import { HomeComponent } from '../home/home.component';
import { DashboardComponent } from '../users/dashboard/dashboard.component';
import { MainComponent } from './main.component';
import { StudentManagementComponent } from '../admin/student-management/student-management.component';
import { AddQuizComponent } from '../admin/add-quiz/add-quiz.component';
import { PaymentComponent } from '../payment/payment.component';
import { AnnouncementDesignerComponent } from '../admin/announcement-designer/announcement-designer.component';
import { SubscriptionManagementComponent } from '../admin/subscription-management/subscription-management.component';
import { PricingComponent } from '../subscription/pricing/pricing.component';
import { SampleCourseListComponent } from '../courses/sample-course-list/sample-course-list.component';
import { SampleCoursePlayComponent } from '../courses/sample-course-play/sample-course-play.component';

const routes: Routes = [
  {
    path: "",
    component: MainComponent,
    children: [
      { path: "", pathMatch: "full", redirectTo: 'home' },
      { path: "home", component: HomeComponent },
      { path: "about", component: AboutComponent },
      { path: "login", component: LoginComponent },
      { path: "signup", component: SignupComponent },
      {
        path: 'blogs', children: [
          { path: '', pathMatch: 'full', redirectTo: 'topBlogs' },
          { path: 'add', component: AddBlogComponent },
          { path: 'topBlogs', component: BlogsListComponent },
          { path: 'all', component: ArchivalComponent }
        ]
      },
      { path: 'contact', component: ContactComponent },
      { path: 'admin/courses', component: CourseWizardComponent },
      { path: 'admin/announcement-design', component: AnnouncementDesignerComponent },
      { path: 'admin/manageUsers', component: StudentManagementComponent },
      { path: 'admin/manageSubscriptions', component: SubscriptionManagementComponent },
      { path: 'courses', component: CourseListComponent },
      { path: 'sample-courses', component: SampleCourseListComponent },
      { path: 'courses/details/:courseId', component: CourseDetailsComponent },
      { path: 'courses/play/:courseId', component: CoursePlayComponent },
      { path: 'sample-courses/play/:courseId', component: SampleCoursePlayComponent },
      { path: 'courses/add', component: AddCourseComponent },
      { path: 'courses/:courseId/modules/add', component: AddModuleComponent },
      { path: 'courses/:courseId/modules/:moduleId/lessons/add', component: AddLessonComponent },
      { path: 'courses/:courseId/modify', component: AddCourseComponent },
      { path: 'courses/:courseId/modules/:moduleId/modify', component: AddModuleComponent },
      { path: 'courses/:courseId/modules/:moduleId/quiz/:quizId/modify', component: AddQuizComponent },
      { path: 'courses/:courseId/modules/:moduleId/lessons/:lessonId/modify', component: AddLessonComponent },
      { path: 'student/:studentId/dashboard', component: DashboardComponent },
      { path: ':userId/cart', component: CartComponent },
      { path: ':userId/:courseId/payment', component: PaymentComponent },
      { path: 'pricing', component: PricingComponent }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
